import BillingAddressFormContainer from './billing-address-form-container';

export default BillingAddressFormContainer;
